import { isEligible } from '@/server-data'

export default function validateTimeWindowExceptionDate(
  date: string,
  eligibility: uui.domain.client.rm.Eligibility,
): boolean {
  return isEligible(eligibility, date)
}
